import React, {useContext, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {GetTextColor} from "./GetTextColor";

const CustomItemModal = (props) => {
    const RecordController = useContext(RecordsManagementContext);
    let defaultRoomEstimateId = props.DefaultEstimateRoomId;
    let defaultRoomId = props.DefaultRoomId;
    let CustomInventoryHash = props.CustomInventoryHash;
    const [CustomItemName, SetCustomItemName] =useState('');
    const [CustomItemCuft, SetCustomItemCuft] =useState('');
    const [CustomItemLbs, SetCustomItemLbs] =useState('');
    const [CustomItemMovingTime, SetCustomItemMovingTime] =useState('');
    const [CustomItemQty, SetCustomItemQty] =useState('');
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;

    const ValidateInputs = () => { // add required field to last empty field
        let element = document.getElementsByClassName("required-field-value") // add required class
        for ( let i = 0; i < element.length; i++) {
            if ( element[i]["value"] === "") {
                element[i].setAttribute('style', 'border: 2px solid red');
                return false
            }
        }
    }

    const RevertInputBorder = () => { //remove the required for other fields except last empty
        let element = document.getElementsByClassName("required-field-value") // add required class
        for ( let i = 0; i < element.length; i++) {
            element[i].setAttribute('style', 'border: none');
        }
    }
    const AddCustomItem = async () => { // add custom item for particular default room
        RevertInputBorder();// check validation of last empty input
        let checkValidation = await ValidateInputs() // check validations for all fields
        if (checkValidation === undefined) {
            let customInventory = {}
            customInventory[CustomItemName] = {  Id: "new_custom_item",
                Name: CustomItemName,
                Qty: parseInt(CustomItemQty),
                InvenVolume: CustomItemCuft,
                InvenWeight: CustomItemLbs,
                InvenMovingTime: CustomItemMovingTime,
                InventoryId: CustomItemName,
                RoomEstimateId: defaultRoomEstimateId,
                default_room_id: defaultRoomId,
            }
            RecordController.SetDefaultRoomHash({
                ...RecordController.DefaultRoomHash,
                customInventoryHash : {
                    ...CustomInventoryHash, ...customInventory
                }
            })
            RecordController.setCustomItemModal(false);
            RecordController.SetActiveButton(true);
        }
    }
    return (
        <>
            <form className={'custom-item-form'}>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                            <label className="col-form-label required-field">Item Name</label>
                            <input type="text" className="form-control required-field-value" value = {CustomItemName}
                                   onChange={(e)=>{SetCustomItemName(e.target.value)}}
                            />
                    </div>
                    <div className="col-md-6 col-sm-6 col-6">
                            <label className="col-form-label required-field">CUft</label>
                            <input type="text" className="form-control required-field-value" value={CustomItemCuft}
                                   onChange={(e)=>{SetCustomItemCuft(e.target.value.replace(/\D/g, ""))}}/>
                    </div>
                    <div className="col-md-6 col-sm-6 col-6">
                            <label className="col-form-label required-field">Lbs</label>
                            <input type="text" className="form-control required-field-value" value={CustomItemLbs}
                                   onChange={(e)=>{SetCustomItemLbs(e.target.value.replace(/\D/g, ""))}}/>
                    </div>
                    <div className="col-md-6 col-sm-6 col-6">
                            <label className="col-form-label required-field">Moving Time</label>
                            <input type="text" className="form-control required-field-value" value={CustomItemMovingTime}
                                   onChange={(e)=>{SetCustomItemMovingTime(e.target.value.replace(/\D/g, ""))}}/>
                    </div>
                    <div className="col-md-6 col-sm-6 col-6">
                            <label className="col-form-label required-field">Quantity</label>
                            <input type="text" className="form-control required-field-value" value={CustomItemQty}
                                   onChange={(e)=>{SetCustomItemQty(e.target.value.replace(/\D/g, ""))}}/>
                    </div>
                </div>
            </form>
            <div className="modal-footer">
                <button className="btn btn-st-model-add" type="submit" onClick={()=>AddCustomItem()} style={{backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor),width: "80%"}}>Add Item<i className="fa fa-plus" style={{float: "right"}}></i></button>
            </div>
          </>
    );
}
export default CustomItemModal;